import api from "./api";
import {
  ApiResponse,
  IletisimBilgileri,
  IletisimBilgileriUpdateDTO,
  IletisimForm,
  IletisimFormCreateDTO,
} from "./types";

export const IletisimService = {
  iletisimBilgileriGetir: async () => {
    const response = await api.get<ApiResponse<IletisimBilgileri[]>>(
      "/api/Iletisim/IletisimBilgileri"
    );
    return response.data;
  },

  iletisimBilgileriGuncelle: async (data: IletisimBilgileriUpdateDTO) => {
    //admin yapabilir
    const response = await api.put<ApiResponse<IletisimBilgileri>>(
      "/api/Iletisim/IletisimBilgileri/Guncelle",
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  iletisimFormListele: async () => {
    const response = await api.get<ApiResponse<IletisimForm[]>>(
      "/api/Iletisim/IletisimForm"
    );
    return response.data;
  },

  iletisimFormEkle: async (data: IletisimFormCreateDTO) => {
    //kullanıcı yapabilir
    const response = await api.post<ApiResponse<IletisimForm>>(
      "/api/Iletisim/IletisimForm/Ekle",
      data
    );
    return response.data;
  },

  iletisimFormSil: async (id: string) => {
    //admin yapabilir
    const response = await api.delete<ApiResponse<boolean>>(
      `/api/Iletisim/IletisimFormSil/${id}`
    );
    return response.data;
  },
};
